export const BASE_ADDRESS =
  process.env.NODE_ENV !== "production" ? "http://localhost:3001/api" : "/api";

export const ADDRESS_AUTOCOMPLETE = `${BASE_ADDRESS}/street-guide?q=`;
export const COVERAGE_CHECK = `${BASE_ADDRESS}/coverage-check?`;
export const PACKAGES = `${BASE_ADDRESS}/packages`;
export const SUBSCRIBER = `${BASE_ADDRESS}/subscriber`;
export const UPLOADED = `${SUBSCRIBER}/uploaded`;
export const CONTACT_ME = `${BASE_ADDRESS}/contact-me`;
